import React, { Component } from 'react';
import Hero from '../parts/Hero';
import ViewedSection from '../parts/ViewedSection';
import Data from '../json/dataLandingPage.json';

const LandingPage = (props) => {
    return (
    <div>
        <Hero isLogIn={props.isLogIn}/>
        <ViewedSection data={Data.viewedSection}/>

    </div>
)}

export default LandingPage;
